import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "@/hooks/use-toast";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";

interface UseDeleteAccountOptions {
  onSuccess?: () => void;
}

export const useDeleteAccount = (options: UseDeleteAccountOptions = {}) => {
  const { del } = useAuthenticatedApiRequest();
  const queryClient = useQueryClient();
  const { t } = useTranslation("settings");

  const deleteAccount = async () => {
    const response = await del(new TchrURL("/user"));
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  return useMutation({
    mutationKey: ["user", "delete"],
    mutationFn: deleteAccount,
    onSuccess: () => {
      toast({
        title: t("deleteAccount.toast.success.title"),
        description: t("deleteAccount.toast.success.description"),
      });
      queryClient.removeQueries({ queryKey: ["user"] });
      queryClient.invalidateQueries({ queryKey: ["init"] });
      options.onSuccess?.();
    },
    onError: () => {
      toast({
        title: t("deleteAccount.toast.error.title"),
        description: t("deleteAccount.toast.error.description"),
        variant: "destructive",
      });
    },
  });
};
